export function saveByteArray(buffer, filename, mimeType) {
    const blob = new Blob([buffer], { type: mimeType });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  }
  